import React, { useState } from 'react';
import { useField } from "formik";
import { Alert } from 'reactstrap';

// User messages of all kind
export const AlertUser = (props) => {
  const [visible, setVisible] = useState(true);

  const onDismiss = () => { 
    setVisible(false);
    // wait for fade-out before trigger re-rendering
    setTimeout(() => { props.action() }, 600);
  }

  return (
    <Alert color={props.type} isOpen={visible} toggle={onDismiss} className="container">
      {props.txt}
    </Alert>
  );
}
export default AlertUser;



// element: input text
export const TextInput = ({ label, ...props }) => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    const [field, meta] = useField(props);
    return (
      <>
        <div className="m-0"><label className="mb-0" htmlFor={props.id || props.name}>{label}</label></div>
        <div className="m-0"> 
          <input className="text-input" {...field} {...props} autoComplete="off" />
          {meta.touched && meta.error ? ( <div className="error">{meta.error}</div>) : null}
        </div>
      </>
    );
  };


// element: checkboxes 
export const Checkbox = ({ children, ...props }) => {
  const [field] = useField({ ...props, type: "checkbox" });
  return (
    <>
      <label className="checkbox m-0"> <input {...field} {...props} type="checkbox" /> {children} </label>
      {/** meta.touched && meta.error ? (<div className="error">{meta.error}</div>) : null */}
    </>
  );
};

// element: radio buttons
export const Radiobutton = ({ label, ...props }) => {
  const [field, meta] = useField(props);
 
  // TODO: map! dynamic values/choices
  return (
    <>
      <div className="mr-4"><label htmlFor={props.id || props.name}>{label}</label></div>
      <label className="mr-3 radio-inline font-weight-light"><input {...field} {...props} name={props.name} type="radio" value={props.values[0]}/> {props.values[0]}</label> 
      <label className="mr-3 radio-inline font-weight-light"><input {...field} {...props} name={props.name} type="radio" value={props.values[1]}/> {props.values[1]}</label> 
      <label className="mr-3 radio-inline font-weight-light"><input {...field} {...props} name={props.name} type="radio" value={props.values[2]}/> {props.values[2]}</label> 
      {meta.touched && meta.error ? (<div className="error">{meta.error}</div>) : null}
    </>
  );
};